import styled from 'styled-components';

export const FileCardWrapper = styled.div`
    display: flex;
    padding: 10px;
    border-radius: 10px;
    background: #f8f8f8;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
    max-width: 700px;
`;

export const Flag = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10px;
    width: 15px;
`;

export const FlagWrapper = styled.div`
    position: relative;
    width: auto;
    height: 30px;
    z-index: 100;
    overflow: hidden;
    top: 2px;
`;

export const FilenameBox = styled.div`
  position: relative;
  max-width: 300px;
`;

/* Sam tekst może mieć elipsę i overflow hidden — ale preview NIE siedzi w tym elemencie */
export const FilenameEllipsis = styled.span`
  display: inline-block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ImageThumbnail = styled.div<{ $imageUrl: string }>`
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background-image: url('${({ $imageUrl }) => $imageUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
`;

export const PreviewPopover = styled.div`
  position: absolute;
  top: -210px;
  right: -10px;
  width: 200px;
  height: 200px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 8px;
  z-index: 9999;
  pointer-events: none; /* nie "zjada" hovera */
`;
